export default "__VITE_ASSET__e17d48d9__"